import { ThemeProvider } from 'styled-components';
import { CurrentUserProvider } from '~contexts/CurrentUserContext';
import GlobalStyle from '~components/dumbs/GlobalStyle';
import theme from '~theme';
import Routes from '~routes';
import LayoutProvider from '~contexts/LayoutContext';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <CurrentUserProvider>
        <LayoutProvider>
          <Routes />
          <div className="portal-root"></div>
        </LayoutProvider>
      </CurrentUserProvider>
    </ThemeProvider>
  );
}

export default App;
